import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ChatInputRedirect.css';
import { MicIcon } from '../Icons'; // Đảm bảo đường dẫn đúng
import { ArrowRight } from 'lucide-react';
// Giả sử bạn muốn chuyển hướng đến trang chat mới khi click
const DEFAULT_REDIRECT_PATH = '/chat/new';

export default function ChatInputRedirect({ redirectTo = DEFAULT_REDIRECT_PATH }) {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(redirectTo);
    };

    return (
        <div className="chat-input-container redirect" onClick={handleClick}>
            <span className="chat-input-placeholder">Tôi muốn đặt xe</span>
            <div className="icon-wrapper">
                <div className="mic-icon-container">
                    <MicIcon />
                </div>
                <div className="send-icon-container">
                    <ArrowRight color="#fff" />
                </div>
            </div>
        </div>
    );
}